import React from 'react';
import { Pie } from 'react-chartjs-2';

const ProgressByEmotions = () => {
    const data = {
        labels: ['Fear', 'Anger', 'Joy', 'Others'],
        datasets: [
            {
                data: [30, 15, 20, 15],
                backgroundColor: ['#90BCB5', '#F4B3AE', '#FCEBA2', '#BDBDBD'],
                borderWidth: 0,
                offset: 25,
            },
        ],
    };

    const options = {
        plugins: {
            legend: {
                display: false,
            },
            datalabels: {
                display: function(context) {
                  return context.dataset.data[context.dataIndex] > 0;
                },
                color: 'text-gray-900', // Set label text color
                anchor: 'center',
                align: 'center',
                font: {
                  weight: 'bold',
                  family: 'Manrope', 
                  size: '16',
                },
                formatter: (value, context) => {
                  const label = data.labels[context.dataIndex];
                  return `${value}%\n${label}`;
                },
              },
        },
        responsive: true,
        maintainAspectRatio: false,
    };

    return (
        <div className='w-full' style={{ height: '300px' }}>
            <Pie data={data} options={options} />
        </div>
    );
};

export default ProgressByEmotions;